module.exports = __webpack_public_path__ + "img/photo-moh.45c60c5a.jpg";